export default __webpack_public_path__ + "static/media/plain-sticker-ch.680d8b24.png";